module.exports = __webpack_public_path__ + "img/arrow-up-small.2cc96c74.svg";